import axios from "axios";
import React from "react";
import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { t } from "../../../localization/localization";
import semanticScholar from "../../../assets/semantic_scholar_logo.png";
import { Line } from "react-chartjs-2";

const DashboardExternalSemanticScholar = ({ crisId }) => {
  const [isError, setIsError] = useState(false);
  const [externalData, setExternalData] = useState(null);
  const [externalChartData, setExternalChartData] = useState(null);

  const urlSearchParams = new URLSearchParams(window.location.search);
  const locale = urlSearchParams.get("locale") ?? "tr";

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "Researcher's Line Chart",
      },
    },
  };

  const [lineChartData, setLineChartData] = useState({
    labels: [],
    workCount: [],
    citationCount: [],
    influentialCitationCount: [],
  });

  useEffect(() => {
    setLineChartData({
      workCount: externalChartData?.map((sample) => sample?.workCount),
      citationCount: externalChartData?.map((sample) => sample?.citationCount),
      influentialCitationCount: externalChartData?.map(
        (sample) => sample?.influentialCitationCount
      ),
      labels: externalChartData?.map((sample) => sample?.year),
    });
  }, [externalChartData]);

  const data = {
    labels: lineChartData?.labels,
    datasets: [
      {
        label: t(
          locale,
          "/rs/profile/dashboardExternalSemanticScholar/documents"
        ),
        data: lineChartData?.workCount,
        borderColor: "rgb(255, 99, 132)",
        backgroundColor: "rgba(255, 99, 132, 0.5)",
      },
      {
        label: t(
          locale,
          "/rs/profile/dashboardExternalSemanticScholar/citations"
        ),
        data: lineChartData?.citationCount,
        borderColor: "rgb(53, 162, 235)",
        backgroundColor: "rgba(53, 162, 235, 0.5)",
      },
      {
        label: t(
          locale,
          "/rs/profile/dashboardExternalSemanticScholar/influentialCitationCount"
        ),
        data: lineChartData?.influentialCitationCount,
        borderColor: "rgb(41, 280, 41)",
        backgroundColor: "rgba(41, 280, 41, 0.5)",
      },
    ],
  };
  useEffect(() => {
    axios
      .get(
        `${window._env_.BASE_URL}/gcris-api/researcher/${crisId}/external-metrics/semantic-scholar`
      )
      .then((res) => {
        setExternalData(res.data);
      })
      .catch((error) => {
        if (error.response) {
          setIsError(true);
        }
      });
    axios
      .get(
        `${window._env_.BASE_URL}/gcris-api/researcher/${crisId}/pubCountByYears/semantic-scholar`
      )
      .then((res) => {
        setExternalChartData(res.data);
      })
      .catch((error) => {
        if (error.response) {
          setIsError(true);
        }
      });
  }, []);

  return externalData && externalChartData ? (
    <Container fluid>
      <Row className="wall">
        <Col>
          <a
            target="_blank"
            href={externalData.url}
            style={{ textDecoration: "none" }}
          >
            <img
              src={semanticScholar}
              style={{ height: 48, marginBottom: 16 }}
            />

            <Row className="text-center">
              <Col xs="12" md="4">
                <div>
                  <h1 style={{ color: "#001F54" }}>
                    {externalData.paperCount}
                  </h1>
                  <h6 style={{ color: "#275DAD" }}>
                    {t(
                      locale,
                      "/rs/profile/dashboardExternalSemanticScholar/documents"
                    )}
                  </h6>
                </div>
              </Col>
              <Col xs="12" md="4">
                <div>
                  <h1 style={{ color: "#001F54" }}>
                    {externalData.citationCount}
                  </h1>
                  <h6 style={{ color: "#275DAD" }}>
                    {t(
                      locale,
                      "/rs/profile/dashboardExternalSemanticScholar/citations"
                    )}
                  </h6>
                </div>
              </Col>
              <Col xs="12" md="4">
                <div>
                  <h1 style={{ color: "#001F54" }}>{externalData.hIndex}</h1>
                  <h6 style={{ color: "#275DAD" }}>
                    {t(
                      locale,
                      "/rs/profile/dashboardExternalSemanticScholar/hIndex"
                    )}
                  </h6>
                </div>
              </Col>
            </Row>
            <Row style={{ display: "flex", justifyContent: "center" }}>
              <Col sm="12" md="10" lg="6">
                <Line options={options} data={data}></Line>
              </Col>
            </Row>
            <Row className="text-center">
              Semantic Scholar
              {t(locale, "/rs/profile/valid-for-all-publications")}
            </Row>
          </a>
        </Col>
      </Row>
    </Container>
  ) : isError ? (
    <div></div>
  ) : (
    <div>Loading Semantic Scholar Data...</div>
  );
};

export default DashboardExternalSemanticScholar;
